export default "__VITE_ASSET__e8a8c7fe__"